import React, { useEffect } from 'react'
import { Link } from 'react-router'
import PropTypes from 'prop-types'
import { browserStorage } from 'Redux/services/storage'
import { Element } from 'react-scroll'
import { checkIsArchive } from 'Utils'
import { urlSearchParamsToObj } from 'Utils/routerUtils'
import FrequencySelect from 'Components/FrequencySelect'
import { frequencyToStringMap } from 'Defaults/inputData'
import ImagePlaceholder from 'Components/ImagePlaceholder'
import errorLogger from 'Root/errorLogger'
import { FormElemGroup } from 'Components/Form'
import ListingImageSlider from '../ListingImageSlider'

import FilterBar from '../FilterBar'
import TitleWithDelete from '../TitleWithDelete'

import {
  _ListingAlertCard,
  _DeletingIndicator,
  _PreviewImgBlock,
  _FrequencyGroup,
  _InfoBlock,
  _AddRecipient,
  _CTA,
  _ImgContainer,
  _AddRecipientMulti,
  _ListingNumbers,
  _Title,
  _FrequencyContainer,
  _AlertToggle,
  _FrequencySelect,
} from './styles'


const bs = browserStorage()
const ListingAlertCard = (
  {
    id, name, isFetching,
    ccList, frequency, onRecipientChange,
    alert, deleteAlert, onFrequencyUpdate, matchedListingCount,
    deletingId, tags, isReComputingTags, allImages, loadAlertListings, googleAnalyticsEvent,
  }) => {
  let isArchive = false
  let title = name
  const { alert_frequency: alertFrequency, url: searchUrl } = alert || {}

  if(searchUrl) {
    const mode = urlSearchParamsToObj(searchUrl.split('?')[1]).mode
    isArchive = checkIsArchive(mode)
    if(isArchive) title += ` - ${mode}`
  }
  useEffect(() => {
    // archive listing need to be fetching from backend
    loadAlertListings({ alertId: id, query: alert.url })
  }, [])

  function handleAlert() {
    deleteAlert(id)
  }

  function handleFrequency(selected) {
    onFrequencyUpdate(alert, selected)
  }

  const toggleSwitch = () => {
    handleFrequency({ value: alertFrequency === 0 ? '1' : '0' })
  }

  function handleRecipientChange(recipients) {
    onRecipientChange(alert, recipients)
  }
  function setEditMode() {
    try {
      bs.setItem(id, JSON.stringify({
        alert,
        backParams: window.location.search,
      }))
    } catch(e) {
      errorLogger('Listing Alert Card alert json parse fail', e)
    }
  }
  return (
    <_ListingAlertCard noWrap>
      <Element name={id} id={`alertCard-${id}`}/>
      {
        id === deletingId && <_DeletingIndicator/>
      }

      <_PreviewImgBlock
        direction={'col'}
        center
        as={Link}
        to={`/${searchUrl}`}
        onClick={() => googleAnalyticsEvent({
          category: 'ListingAlertCard',
          action: '[Alert Card click]',
        })}
      >
        {
          allImages && allImages.length ? (
            <_ImgContainer>
              <ListingImageSlider imageSrcList={allImages} title={title}/>
            </_ImgContainer>
          ) : (
            <ImagePlaceholder defaultSrc={''} src="" alt="default loading photo"/>
          )
        }
        <_ListingNumbers>{isFetching ? 'Loading' : `${matchedListingCount} Listings`}</_ListingNumbers>
        <_CTA>
          Listings that match your criteria
        </_CTA>

      </_PreviewImgBlock>

      <_InfoBlock>
        <TitleWithDelete title={title} deleteAlert={handleAlert}/>
        <FilterBar
          url={searchUrl ? `/${searchUrl}#alert_id=${id}` : ''}
          onEditClick={setEditMode}
          tags={tags}
          isReComputingTags={isReComputingTags}
        />
        <_FrequencyContainer>
          <_Title>Alert Emails & Notifications</_Title>
          <_FrequencyGroup marginBottomMag={1}>
            <_AlertToggle
              data-test-id={`listingAlertSwitch-${id}`}
              inputId={`listingAlertSwitch-${id}`}
              key={`listingAlertToggle-${id}`}
              isOn={alertFrequency !== 0}
              onChange={toggleSwitch}
              onLabel={'ON'}
              offLabel={'OFF'}
            >{alertFrequency !== 0 ? 'On' : 'Off'}
            </_AlertToggle>
            {
              alertFrequency !== 0 && (
                <_FrequencySelect>
                  <FrequencySelect
                    title={frequencyToStringMap[frequency]}
                    frequencyId={frequency}
                    onSelect={handleFrequency}
                    blurBackground={false}
                  />
                </_FrequencySelect>
              )
            }
          </_FrequencyGroup>
        </_FrequencyContainer>
        <_AddRecipient>
          <FormElemGroup marginBottomMag={1}>
            <_AddRecipientMulti
              marginBottomMag={1}
              initCcList={ccList}
              onRecipientChange={handleRecipientChange}
            />
          </FormElemGroup>
        </_AddRecipient>
      </_InfoBlock>
    </_ListingAlertCard>
  )
}
ListingAlertCard.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  ccList: PropTypes.string,
  allImages: PropTypes.arrayOf(PropTypes.string),
  frequency: PropTypes.number,
  matchedListingCount: PropTypes.number,
  onRecipientChange: PropTypes.func,
  alert: PropTypes.shape({
    alert_frequency: PropTypes.number,
    id: PropTypes.string,
    url: PropTypes.string,
    search_url: PropTypes.string,
  }),
  deleteAlert: PropTypes.func,
  deletingId: PropTypes.string,
  tags: PropTypes.string,
  onFrequencyUpdate: PropTypes.func,
  loadAlertListings: PropTypes.func,
  isReComputingTags: PropTypes.bool,
  isFetching: PropTypes.bool,
  googleAnalyticsEvent: PropTypes.func,
}


export default (ListingAlertCard)
